import { callDelete, get } from "@/services/api.services";
import { Protocol, Thing } from "@/services/things/models";

export const thingAPI = {
    fetchProtocolByCode: async (protocolCode: string): Promise<Protocol> => {
        return get(`/things/protocols/${protocolCode}`);
    },
    fetchProtocolsByCodes: async (protocolCodes: string[]): Promise<Protocol[]> => {
        const queryString = protocolCodes
            .map((protocolCode) => {
                return `protocolCodes=${protocolCode}`;
            })
            .join("&");
        return get(`/things/protocols?${queryString}`);
    },
    fetchExperimentByCode: async (experimentCode: string) => {
        return get(`/things/experiments/${experimentCode}`);
    },
    fetchThingsForSchema: async (
        protocolCode: string,
        experimentCode: string,
        thingSchemaId: string
    ): Promise<Thing[]> => {
        return get(
            `/things/protocols/${protocolCode}/experiments/${experimentCode}/things/${thingSchemaId}`
        );
    },
    fetchFilteredThingsForSchema: async (
        protocolCode: string,
        experimentCode: string,
        thingSchemaId: string,
        dataCollectionTaskId: string
    ) => {
        return get(
            `/things/protocols/${protocolCode}/experiments/${experimentCode}/things/${thingSchemaId}/tasks/${dataCollectionTaskId}`
        );
    },
    fetchThingSchemaIdsByThingIdMap: async (protocolCode: string, experimentCode: string) => {
        return get(
            `/things/protocols/${protocolCode}/experiments/${experimentCode}/thingSchemaIdsByThingId`
        );
    },
    fetchThingsForSchemas: async (
        protocolCode: string,
        experimentCode: string,
        thingSchemaIds: string
    ) => {
        return get(`/things/protocols/${protocolCode}/experiments/${experimentCode}/things`, {
            params: { thingSchemaIds },
        });
    },
    searchThings: async (
        protocolCode: string,
        experimentCode: string,
        thingSchemaId: string,
        query: string
    ) => {
        return get(
            `/things/protocols/${protocolCode}/experiments/${experimentCode}/thingSearch/${thingSchemaId}?q=${encodeURIComponent(query)}`
        );
    },
    deleteThings: async (experimentCode: string, thingIds: string[]) => {
        const queryString = thingIds
            .map((thingId) => {
                return `thingIds=${thingId}`;
            })
            .join("&");
        return callDelete(`/things/experiments/${experimentCode}/things?${queryString}`);
    },
};
